export const ProspectApprovalStatus = Object.freeze({
  WAITING_FOR_SUPERVISOR: 'WAITING_FOR_SUPERVISOR',
  WAITING_FOR_AGENT: 'WAITING_FOR_AGENT',
  APPROVED: 'APPROVED',
});

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ProspectApprovalStatus = typeof ProspectApprovalStatus[keyof typeof ProspectApprovalStatus];
